import { useEffect } from "react";
import { Box, Button, Dialog, DialogContent, IconButton, Typography } from "@mui/material";
import { Check, Close } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { accountDialogPaperSx } from "../components/DeleteAccountDialog";

const AccountDeleted = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const returnHome = () => navigate("/", { replace: true });

  useEffect(() => {
    const timeout = window.setTimeout(() => navigate("/login", { replace: true }), 5000);
    return () => window.clearTimeout(timeout);
  }, [navigate]);

  return (
    <Dialog open onClose={returnHome} aria-labelledby="account-deleted-title"
      aria-describedby="account-deleted-description" PaperProps={{ sx: accountDialogPaperSx }}>
      <Box sx={{ display: "flex", justifyContent: "flex-end", p: 1 }}>
        <IconButton aria-label={t("accountDeleteClose")} onClick={returnHome}><Close /></IconButton>
      </Box>
      <DialogContent sx={{ px: { xs: 3, sm: 4 }, pb: 4, pt: 1, textAlign: "center" }}>
        <Box sx={{ borderRadius: "50%", bgcolor: "#e3f8ec", color: "#11934a", width: 96, height: 96,
          display: "flex", alignItems: "center", justifyContent: "center", mx: "auto", mb: 3 }}>
          <Check sx={{ fontSize: 56 }} />
        </Box>
        <Typography id="account-deleted-title" component="h1" variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
          {t("accountDeleteSuccessTitle")}
        </Typography>
        <Typography id="account-deleted-description" sx={{ mb: 4, lineHeight: 1.65 }}>{t("accountDeleteSuccessDescription")}</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>{t("accountDeleteRedirect")}</Typography>
        <Button fullWidth variant="contained" size="large" onClick={returnHome}>{t("accountDeleteReturnHome")}</Button>
      </DialogContent>
    </Dialog>
  );
};

export default AccountDeleted;
